interface ProjectDisplayNameArgs {
  name: string;
  fortnoxId?: string | null;
}
export const toProjectDisplayName = ({
  name,
  fortnoxId,
}: ProjectDisplayNameArgs): string => {
  return `${fortnoxId ?? ''} - ${name}`;
};
